import axios from 'axios';
import { matchPath } from 'react-router-dom';
import { DEFAULT_LANG_PARAM_NAME } from 'utils/pathFactory';
import { xlf2json } from 'utils/xlf2json';
import { config } from './config';

type Messages = Record<string, string> | undefined;

export let defaultMessages: Messages;
export let requestedMessages: Messages;

export async function loadDefaultMessages(): Promise<void> {
  defaultMessages = await loadMessages(config.defaultLanguage);
}

export async function loadRequestedMessages(): Promise<void> {
  requestedMessages = await loadMessages(parseLanguage());
}

export async function getMessages(lang?: string): Promise<Messages> {
  if (lang) {
    if (lang === config.defaultLanguage && defaultMessages) {
      return defaultMessages;
    }

    return loadMessages(lang).then(messages => messages || defaultMessages);
  }

  return requestedMessages || defaultMessages;
}

export function parseLanguage(): string {
  const langPathPattern = `${config.publicUrl}/${DEFAULT_LANG_PARAM_NAME}/*`;
  const match = matchPath(langPathPattern, window.location.pathname);

  return match && match.params.lang ? match.params.lang : config.defaultLanguage;
}

export async function loadMessages(lang: string): Promise<Messages> {
  return fetchMessages(lang).then(
    xliff => {
      if (xliff) {
        return xlf2json(xliff);
      }

      return undefined;
    },
    err => {
      console.log(err);
      return undefined;
    },
  );
}

export async function fetchMessages(lang: string): Promise<string> {
  return axios.get(`${window.location.origin}${config.publicUrl}/translations/${lang}.xlf`).then(
    res => res.data,
    err => {
      console.error(err);
      return null;
    },
  );
}
